const PREVIEW_PATH_PATTERN = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?preview\/?$/i

export function isTrackingDisabledPath(path: string) {
  const pathname = path.split(/[?#]/, 1)[0] ?? ''

  return PREVIEW_PATH_PATTERN.test(pathname)
}

export function isTrackingDisabledForCurrentPath() {
  return typeof window !== 'undefined'
    && isTrackingDisabledPath(window.location.pathname)
}
